<template>
  <div class="choose_body">
    <div class="choose-container" >
    <div class="choose-01">
      <div :class="['click_area', { 'point_box': activeIndex === 0 }]" @click="GotoDetailView('01')"></div>
      <img src="../assets/choose/select/choose_select01.png" alt="">
    </div>
    <div class="choose-02">
      <div :class="['click_area', { 'point_box': activeIndex === 1 }]" @click="GotoDetailView('02')"></div>
      <img src="../assets/choose/select/choose_select02.png" alt="">
    </div>
    <div class="choose-03">
      <div :class="['click_area', { 'point_box': activeIndex === 2 }]" @click.stop="GotoDetailView('03')"></div>
      <img src="../assets/choose/select/choose_select03.png" alt="">
    </div>
    <div class="choose-04">
      <div :class="['click_area', { 'point_box': activeIndex === 3 }]" @click="GotoDetailView('04')"></div>
      <img src="../assets/choose/select/choose_select04.png" alt="">
    </div>
    <div class="choose-05">
      <div :class="['click_area', { 'point_box': activeIndex === 4 }]" @click="GotoDetailView('05')"></div>
      <img src="../assets/choose/select/choose_select05.png" alt="">
    </div>
    <div class="choose-06">
      <div :class="['click_area', { 'point_box': activeIndex === 5 }]" @click="GotoDetailView('06')"></div>
      <img src="../assets/choose/select/choose_select06.png" alt="">
    </div>
    <div class="choose-07">
      <div :class="['click_area', { 'point_box': activeIndex === 6 }]" @click="GotoDetailView('07')"></div>
      <img src="../assets/choose/select/choose_select07.png" alt="">
    </div>
    <div class="choose-08">
      <div :class="['click_area', { 'point_box': activeIndex === 7 }]" @click="GotoDetailView('08')"></div>
      <img src="../assets/choose/select/choose_select08.png" alt="">
    </div>
    <div class="choose-09">
      <div :class="['click_area', { 'point_box': activeIndex === 8 }]" @click="GotoDetailView('09')"></div>
      <img src="../assets/choose/select/choose_select09.png" alt="">
    </div>
    <div class="choose-10">
      <div :class="['click_area', { 'point_box': activeIndex === 9 }]" @click="GotoDetailView('10')"></div>
      <img src="../assets/choose/select/choose_select10.png" alt="">
    </div>
    <div class="time-container">

    </div>
  </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import { useRouter } from 'vue-router'
import { ref, onMounted, onUnmounted } from 'vue'

const router = useRouter()

// 当前激活的元素索引
const activeIndex = ref(0)
let intervalTimer = null

// 启动循环动画
const startAnimation = () => {
  intervalTimer = setInterval(() => {
    activeIndex.value = (activeIndex.value + 1) % 10 // 循环0-9 (对应01-10)
  }, 2000) // 每秒切换一次
}

// 停止循环动画
const stopAnimation = () => {
  if (intervalTimer) {
    clearInterval(intervalTimer)
    intervalTimer = null
  }
}

onMounted(() => {
  startAnimation()
})

onUnmounted(() => {
  stopAnimation()
})

const GotoDetailView = async (id) => {

  
  // 跳转到详情页面
  router.push({
    path: '/detail',
    query: id ? { id } : {}
  })
}


</script>

<style lang="scss" scoped>
.choose_body{
  width: 100vw; /* 根据需求调整宽度 */
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #53413D;
  @media screen and (min-width: 1024px){
        max-width: 677px !important;
        margin: auto !important;
        overflow: hidden;
    }
}
.choose-container {
  background-image: url('../assets/choose/choose_bg.jpg');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative; /* 关键：作为定位父级 */
  display: flex;
  width: 100%;
  flex-direction: column; /* 垂直排列 */
  padding-top: 496px;
  box-sizing: border-box;
  justify-content: flex-start; /* 确保子元素从顶部开始排列 */
  align-items: center; /* 水平居中对齐子元素 */
  @media screen and (min-width: 1024px){
    height: 100%;
  }
  &>*{
    pointer-events: none;
  }
}
@keyframes dongBounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-20px);
      }
    }
.click_area{
    width: 60px;
    height: 110px;
    position: absolute;
    top: 15%;
    left: 13%;
    z-index: 1;
    pointer-events: visible;
    &.point_box::before{
      content: '';
      width: 61px;
      height: 97px;
      background: url(~@/assets/choose/hand.png)no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -150px;
      left: 0;
      animation: dongBounce 1.2s ease-in-out infinite;
    }
  }
.choose-01{
  position: absolute;
  width: 154px;
  height: 144px;
  top: 378px;
  left: 11px;
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-02{
  position: absolute;
  width: 146px;
  height: 136px;
  top: 381px;
  left: 84px;
  .click_area{
    top: 10%;
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-03{
  position: absolute;
  width: 145px;
  height: 142px;
  top: 384px;
  left: 149px;
  .click_area{
    left: 10%;
    top: 9%;
    width: 60px;
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-04{
  position: absolute;
  width: 155px;
  height: 157px;
  top: 390px;
  left: 212px;
  .click_area{
    top: 7%;
    transform: rotate(12deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-05{
  position: absolute;
  width: 164px;
  height: 166px;
  top: 405px;
  left: 272px;
  .click_area{
    top: 7%;
    transform: rotate(17deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-06{
  position: absolute;
  width: 171px;
  height: 173px;
  top: 428px;
  left: 331px;
  .click_area{
    top: 7%;
    left: 17%;
    transform: rotate(24deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-07{
  position: absolute;
  width: 177px;
  height: 180px;
  top: 455px;
  left: 385px;
  .click_area{
    top: 7%;
    left: 22%;
    transform: rotate(29deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-08{
  position: absolute;
  width: 180px;
  height: 185px;
  top: 491px;
  left: 440px;
  .click_area{
    top: 7%;
    left: 22%;
    transform: rotate(29deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-09{
  position: absolute;
  width: 181px;
  height: 187px;
  top: 532px;
  left: 490px;
  .click_area{
    top: 7%;
    left: 22%;
    transform: rotate(44deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.choose-10{
  position: absolute;
  width: 181px;
  height: 185px;
  top: 583px;
  left: 536px;
  .click_area{
    top: 18%;
    left: 22%;
    width: 120px;
    transform: rotate(47deg);
  }
  img{
    width: 100%;
    height: 100%;
  }
}


.time-container{
  /* 设置背景图 */
  background-image: url('../assets/choose/time.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 736px;
  height: 838px;
    /* 水平居中 */
  margin: 0 auto;
  position: relative;
  z-index: 10;
  pointer-events: none;
  @media screen and (min-width: 1024px){ 
    width: 90%;
    height: 100%;
    margin-top: 250px;
    position: absolute;
    bottom: -40%;
    left: 50%;
    transform: translateX(-50%);
  } 
}
</style>
